<template>
  <div class="d-book-user-reviews-overall">
    <!-- Overall rating -->
    <div class="overall-rating grid-flex grid-middle grid-no-response">
      <div class="grid-item-shrink">
        <DuiRating
          class="rating-lg"
          :value="averageRating"
        />
      </div>
      <div
        v-if="!!averageRating"
        class="grid-item"
      >
        <p class="average-rating font-alt large">
          <strong>{{ averageRating }} out of 5</strong>
        </p>
      </div>
    </div>
    <!-- END Overall rating -->

    <p class="average-rating-copy">
      <span v-if="!!countTotal">
        Average score based on
        <a
          class="user-reviews-link"
          :href="bookUserReviewsUrl"
          title="View user reviews"
        >
          {{ countTotal }} {{ countTotal | duiPluralize('review', 'reviews') }}
        </a>
      </span>
      <span v-else>No user reviews yet.</span>
    </p>

    <div class="space-top-2em">
      <DReviewsCount
        :num-reviews="countFive"
        :percentage="percentages.five"
        :rating="5"
        title="View 5 star reviews"
        @click="selectRating(5)"
      />
      <DReviewsCount
        :num-reviews="countFour"
        :percentage="percentages.four"
        :rating="4"
        title="View 4 star reviews"
        @click="selectRating(4)"
      />
      <DReviewsCount
        :num-reviews="countThree"
        :percentage="percentages.three"
        :rating="3"
        title="View 3 star reviews"
        @click="selectRating(3)"
      />
      <DReviewsCount
        :num-reviews="countTwo"
        :percentage="percentages.two"
        :rating="2"
        title="View 2 star reviews"
        @click="selectRating(2)"
      />
      <DReviewsCount
        :num-reviews="countOne"
        :percentage="percentages.one"
        :rating="1"
        title="View 1 star reviews"
        @click="selectRating(1)"
      />
    </div>
  </div>
</template>

<script>
import DReviewsCount from './d-reviews-count/d-reviews-count.vue';
import URLS from '@d-shared/urls/urls';
import Window from '@d-shared/utils/window';

import NO_COMMENTS_IMG from '@d-assets/no-comment.svg';

export default {
  components: {
    DReviewsCount,
  },
  props: {
    bookSlug: {
      type: String,
      required: true,
    },
    countOne: {
      type: Number,
      required: true,
    },
    countTwo: {
      type: Number,
      required: true,
    },
    countThree: {
      type: Number,
      required: true,
    },
    countFour: {
      type: Number,
      required: true,
    },
    countFive: {
      type: Number,
      required: true,
    },
    countTotal: {
      type: Number,
      required: true,
    },
    isUserReviewsList: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    averageRating: null,
    bookUserReviewsUrl: null,
    emptyImageSrc: NO_COMMENTS_IMG,
    percentages: {
      one: 0,
      two: 0,
      three: 0,
      four: 0,
      five: 0,
    },
  }),
  computed: {
    isUserReviewsListPresent() {
      return this.$store.getters['BookUserReviews/get-is-user-reviews-list-present'];
    },
  },
  mounted() {
    this.calculateAverageRating();
    this.calculatePercentages();
    this.setBookUserReviewsUrl();
  },
  methods: {
    calculateAverageRating() {
      if (!this.countTotal) {
        return;
      }

      const averageRating = Math.round(
        (this.countOne + (this.countTwo * 2) + (this.countThree * 3) + (this.countFour * 4) + (this.countFive * 5))
        / this.countTotal
      );
      this.$set(this, 'averageRating', averageRating);
    },

    calculatePercentages() {
      if (!this.countTotal) {
        return;
      }

      this.setPercentage('one', this.countOne, this.countTotal);
      this.setPercentage('two', this.countTwo, this.countTotal);
      this.setPercentage('three', this.countThree, this.countTotal);
      this.setPercentage('four', this.countFour, this.countTotal);
      this.setPercentage('five', this.countFive, this.countTotal);
    },

    selectRating(rating) {
      if (!this.isUserReviewsListPresent) {
        Window.goTo(this.bookUserReviewsUrl);
        return;
      }

      this.$store.dispatch('BookUserReviews/selectRating', rating);
    },

    setBookUserReviewsUrl() {
      this.$set(this, 'bookUserReviewsUrl', URLS.app.bookUserReviews.replace('<book-slug>', this.bookSlug));
    },

    setPercentage(percentageType, counter, total) {
      const percentageValue = Math.round((counter / total) * 100);
      this.$set(this.percentages, percentageType, percentageValue);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@dui-styles/base";

.d-book-user-reviews-overall {
  .overall-rating {
    margin-bottom: $_1em;

    .dui-rating {
      margin-right: $_1em;
    }

    p {
      margin: 0;
    }
  }

  .user-reviews-link {
    color: initial;
    font-weight: normal;
    text-decoration: underline;
  }

  .d-reviews-count {
    margin-bottom: $_1em;
  }
}
</style>
